import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full" }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-row items-center justify-between"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Samtale", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "chat-message-divider" }, null, -1)

import { ref, computed, inject } from "vue";
import ChatMessage from "@/features/chat-list/ChatMessage.vue";
import NavigationHeader from "@/features/shared/NavigationHeader.vue";
import { useActiveConversationPersistence } from "@/utils/activeConversationPersistence";
import TransferConversationEmail from "@/features/chat-list/TransferConversationEmail.vue";
import ChatTimeline from "@/features/chat-list/ChatTimeline.vue";
import NavigationButton from "@/features/shared/NavigationButton.vue";
import TransferConversation from "@/features/chat-list/TransferConversation.vue";
import { useEmitterOn } from "@/composables/useEmitterOn";
import NoAgentAvailable from "@/features/chat-list/NoAgentAvailable.vue";
import TransferConversationSms from "@/features/chat-list/TransferConversationSms.vue";
import { tenantInjectionKey, connectedServiceInjectionKey, demoModeInjectionKey } from "@/keys";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatList',
  emits: ["close", "back"],
  setup(__props, { emit: __emit }) {

/* eslint-disable @typescript-eslint/no-explicit-any */
const emits = __emit;

const demoMode = inject(demoModeInjectionKey);
const tenant = inject(tenantInjectionKey);
const connectedService = inject(connectedServiceInjectionKey);

const showTransferEmail = ref(false);
const showTransferSms = ref(false);
const showTransfer = ref(false);
const showNoAgentAvailable = ref(false);
const conversation = ref("");

const activeConversationPersistence = useActiveConversationPersistence(connectedService ?? "demo");

conversation.value = demoMode ? "test" : activeConversationPersistence.getState() ?? "";

useEmitterOn("contact-message-sent", msg => {
  if (!conversation.value) {
    conversation.value = msg.conversation;
  }
});

useEmitterOn("no-agents-available", () => {
  showNoAgentAvailable.value = true;
});

function onCloseClick() {
  emits("close");
}

function onBackClick() {
  if (showTransferEmail.value || showTransferSms.value || showTransfer.value) {
    onTransferClose();
  } else {
    emits("back");
  }
}

const isTransferring = computed(() => {
  return showTransfer.value || showTransferEmail.value || showTransferSms.value;
});

function onTransferClick() {
  showTransferSms.value = false;
  showTransferEmail.value = false;
  showTransfer.value = true;
}

function onTransferClose() {
  showTransfer.value = false;
  showTransferEmail.value = false;
  showTransferSms.value = false;
}

function onEmailClick() {
  showNoAgentAvailable.value = false;
  showTransfer.value = false;
  showTransferSms.value = false;
  showTransferEmail.value = true;
}

function onSmsClick() {
  showNoAgentAvailable.value = false;
  showTransfer.value = false;
  showTransferEmail.value = false;
  showTransferSms.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavigationHeader, {
      onClose: onCloseClick,
      onBack: onBackClick,
      "include-back": ""
    }, {
      default: _withCtx(() => [
        (showTransferEmail.value || showTransferSms.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("Flytte samtale")
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              (!isTransferring.value)
                ? (_openBlock(), _createBlock(NavigationButton, {
                    key: 0,
                    onClick: onTransferClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Flytt")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
      ]),
      _: 1
    }),
    (showTransfer.value)
      ? (_openBlock(), _createBlock(TransferConversation, {
          key: 0,
          onEmailClick: onEmailClick,
          onSmsClick: onSmsClick
        }))
      : (showTransferEmail.value && _unref(tenant))
        ? (_openBlock(), _createBlock(TransferConversationEmail, {
            key: 1,
            conversation: conversation.value,
            tenant: _unref(tenant),
            onClose: onTransferClose
          }, null, 8, ["conversation", "tenant"]))
        : (showTransferSms.value && _unref(tenant))
          ? (_openBlock(), _createBlock(TransferConversationSms, {
              key: 2,
              conversation: conversation.value,
              tenant: _unref(tenant),
              onClose: onTransferClose
            }, null, 8, ["conversation", "tenant"]))
          : (showNoAgentAvailable.value)
            ? (_openBlock(), _createBlock(NoAgentAvailable, {
                key: 3,
                onEmailClick: onEmailClick,
                onSmsClick: onSmsClick
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createVNode(ChatTimeline, {
                  tenant: _unref(tenant),
                  conversation: conversation.value
                }, null, 8, ["tenant", "conversation"]),
                _createElementVNode("div", null, [
                  _hoisted_4,
                  _createVNode(ChatMessage, { conversation: conversation.value }, null, 8, ["conversation"])
                ])
              ], 64))
  ]))
}
}

})